import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { withQuery } from '../../../hoc/withGraphql';
import CurrencyManagement from '../../../components/siteadmin/CurrencyManagement';
import Loader from '../../../components/Loader/Loader';
import currenciesQuery from './currenciesQuery.graphql';
import s from './Currency.css';

class Currency extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getCurrencies: PropTypes.array,
    })
  };

  static defaultProps = {
    data: {
      loading: true
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1
    }
  }

  setStateVariable = (variables) => {
    this.setState(variables);
  }

  render() {
    const { data: { getCurrencies, refetch, loading } } = this.props;
    const { currentPage } = this.state;

    return (
      <div>
        {loading && <Loader type={"text"} />}
        {!loading &&
          <CurrencyManagement
            setStateVariable={this.setStateVariable}
            currentPage={currentPage}
            data={getCurrencies}
            refetch={refetch} />
        }
      </div>
    )
  }
}

export default compose(
  withStyles(s),
  withQuery(currenciesQuery, {
    options: (props) => ({
      variables: {
        currentPage: 1,
        requestedFrom: "siteadmin",
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
)(Currency);